export default __webpack_public_path__ + "directory-bdm-800-2bb58eee942c92062ec41b87facb72b8.png";